import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect } from 'react';
export const useLockDocumentScroll = t0 => {
  const $ = _c(3);
  const lock = t0 === undefined ? true : t0;
  let t1;
  let t2;
  if ($[0] !== lock) {
    t1 = () => {
      if (typeof document === "undefined") {
        return;
      }
      const originalStyle = window.getComputedStyle(document.documentElement).overflow;
      if (lock) {
        document.documentElement.style.overflow = "hidden";
      }
      return () => {
        if (lock) {
          document.documentElement.style.overflow = originalStyle;
        }
      };
    };
    t2 = [lock];
    $[0] = lock;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useLayoutEffect(t1, t2);
};